import { phoneNumberApi } from 'app/services/api';

import { phoneNumberTypes } from 'constants/company';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const PHONE_NUMBERS_ACTION_TYPE = createNamedActions('leadSourcePhoneNumbers', {
  GET_PHONE_NUMBERS: 'GET_LEAD_SOURCE_PHONE_NUMBERS',
});

const getPhoneNumbersByTypeAction = params => async dispatch => {
  const { data } = await phoneNumberApi.getNumbers(params);

  return dispatch({
    type: PHONE_NUMBERS_ACTION_TYPE.GET_PHONE_NUMBERS,
    payload: data,
  });
};

export const getMarketingPhoneNumbersAction = catchAsyncActionError(
  data => dispatch =>
    getPhoneNumbersByTypeAction({
      ...data,
      type: phoneNumberTypes.MARKETING_NUMBER,
    })(dispatch),
);
